import { createSlice } from "@reduxjs/toolkit";
import { getExtracurricularList, getExtracurricularDetail, saveExtracurricular, deleteExtracurricular } from "../controller/extracurricular.controller";
import { Extracurricular } from "../types/extracurricularType";
import { SaveResponse } from "../types/common";

interface ExtracurricularState {
  loading: boolean;
  list: Extracurricular[];
  total: { pages: number; data: number };
  detail: Extracurricular | null;
  detailLoading: boolean;
  response: SaveResponse | null;
  error: string | null;
}

const initialState: ExtracurricularState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  detail: null,
  detailLoading: false,
  response: null,
  error: null,
};

const extracurricularSlice = createSlice({
  name: "extracurricular",
  initialState,
  reducers: {
    resetExtracurricularResponse: (state) => {
      state.response = null;
    },
    resetExtracurricularDetail: (state) => {
      state.detail = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExtracurricularList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getExtracurricularList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getExtracurricularList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data ekstrakurikuler";
      })
      .addCase(getExtracurricularDetail.pending, (state) => {
        state.detailLoading = true;
        state.detail = null;
      })
      .addCase(getExtracurricularDetail.fulfilled, (state, action) => {
        state.detailLoading = false;
        state.detail = action.payload.data ?? null;
      })
      .addCase(getExtracurricularDetail.rejected, (state, action) => {
        state.detailLoading = false;
        state.error = action.error.message ?? "Gagal memuat detail ekstrakurikuler";
      })
      .addCase(saveExtracurricular.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveExtracurricular.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveExtracurricular.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan ekstrakurikuler";
      })
      .addCase(deleteExtracurricular.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetExtracurricularResponse, resetExtracurricularDetail } = extracurricularSlice.actions;
export default extracurricularSlice.reducer;
